import React from 'react';
import { Calendar, Tag } from 'lucide-react';
import { cn } from '../../../utils/cn';

const NewsletterListItem = ({ newsletter, isActive, onClick }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'No date';
    const date = new Date(dateString);
    return date?.toLocaleDateString('en-US', { 
      year: 'numeric', 
      month: 'short', 
      day: 'numeric' 
    });
  };

  return (
    <div
      onClick={onClick}
      className={cn(
        "p-4 rounded-lg border cursor-pointer transition-all hover:shadow-md",
        isActive 
          ? "bg-primary/5 border-primary shadow-sm" 
          : "bg-white border-gray-200 hover:border-primary/50"
      )}
    >
      <h3 className={cn(
        "font-semibold text-lg mb-2 line-clamp-1",
        isActive ? "text-primary" : "text-gray-900"
      )}>
        {newsletter?.title}
      </h3>
      {newsletter?.summary && (
        <p className="text-sm text-gray-600 mb-3 line-clamp-2">
          {newsletter?.summary}
        </p>
      )}
      <div className="flex items-center gap-4 text-xs text-gray-500">
        <div className="flex items-center gap-1">
          <Calendar className="w-3 h-3" />
          <span>{formatDate(newsletter?.publishedAt)}</span>
        </div>
        
        {newsletter?.tags && newsletter?.tags?.length > 0 && (
          <div className="flex items-center gap-1">
            <Tag className="w-3 h-3" />
            <span>{newsletter?.tags?.length} tags</span>
          </div>
        )}
      </div>
      {isActive && (
        <div className="mt-2 text-xs font-medium text-primary">
          ← Editing
        </div>
      )}
    </div>
  );
};

export default NewsletterListItem;